import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { easterEggsPlugin } from '../index.js';

export default createWebRegistrationFromManifest(
  easterEggsPlugin.web!,
  {
    JazzModeHost: () => import('./JazzModeHost'),
  },
  {},
);
